import { ClockPickerView } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";

export type DateFieldType = Dayjs | null;

export enum FormFieldTypesAllowed {
  Textfield = "textfield",
  Dropdown = "dropdown",
  Attachment = "attachment",
  REACTIVE_DROPDOWN = "reactive_dropdown",
  DateTime = "dateTime",
  Number = "number",
  Date = "date",
  Time = "time",
}

type FormTextField = {
  type: FormFieldTypesAllowed.Textfield;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
  placeholder?: string;
};

type FormNumberField = {
  type: FormFieldTypesAllowed.Number;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
  placeholder?: string;
};

type FormAutocompleteField = {
  type: FormFieldTypesAllowed.Dropdown;
  label: string;
  id: string;
  multiple: boolean;
  options: any[];
  required: boolean | string;
  disabled?: boolean;
  loading?: boolean;
  getOptionLabel?: (option: any) => string;
};

export type FormReactiveAutocompleteField = {
  type: FormFieldTypesAllowed.REACTIVE_DROPDOWN;
  label: string;
  id: string;
  multiple: boolean;
  // options: any[];
  required: boolean | string;
  disabled?: boolean;
  reactive_key: string;
  get_options: (parent_value: any) => any[];
};

type FormAttachmentField = { type: FormFieldTypesAllowed.Attachment; id: string; required: boolean | string };

type FormDateTimeField = {
  type: FormFieldTypesAllowed.DateTime;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
};

type FormTimeField = {
  type: FormFieldTypesAllowed.Time;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
  views?: ClockPickerView[];
};

type FormDateField = {
  type: FormFieldTypesAllowed.Date;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
  placeholder?: string;
};

export type FormFieldType =
  | FormTextField
  | FormAttachmentField
  | FormAutocompleteField
  | FormReactiveAutocompleteField
  | FormDateTimeField
  | FormDateField
  | FormNumberField
  | FormTimeField;
